import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SearchStar from "../../images/searchStar.png";

const Search = () => {
  const navigate = useNavigate();
  const { searchTerm } = useParams();
  const [searchValue, setSearchValue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate(`/search/${searchValue}`);
  };

  useEffect(() => {
    if (searchTerm) {
      setSearchValue(searchTerm);
    } else {
      setSearchValue("");
    }
  }, [searchTerm]);

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-gray23 rounded-[30px] flex items-center space-x-2 px-2 w-full"
    >
      <input
        className="bg-inherit pl-4 pr-2 py-4 placeholder:text-gray24 text-gray-600 font-urbanist font-medium text-sm flex-1 outline-none border-none rounded-[30px]"
        placeholder="Type something..."
        value={searchValue}
        onChange={(e) => {
          e.preventDefault();
          setSearchValue(e.target.value);
        }}
      />
      <button className="px-4 py-3 rounded-[80px] flex items-center bg-purple1 text-white font-inter font-medium text-xs">
        <img src={SearchStar} alt="star" className="object-contain mr-2" />
        Search
      </button>
    </form>
  );
};

export default Search;
